import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p className="text-center nm">© {new Date().getFullYear()} Nuveen, LLC. All rights reserved.</p>
    </footer>
  );
}
export default Footer;
